import { TicketStatus } from "./type/ticket-status.enum";

export const ColorFromStatus = {
  [TicketStatus.Open]: "info",
  // Fixed material purple (#9C27B0) — same in light & dark themes, unlike the
  // `warning` token which renders red-ish in light and yellow in dark.
  [TicketStatus.Waiting]: "purple",
  [TicketStatus.Closed]: "success",
};

export const IconFromStatus = {
  [TicketStatus.Open]: "mdi-folder-open-outline",
  [TicketStatus.Waiting]: "mdi-clock-outline",
  [TicketStatus.Closed]: "mdi-check-circle-outline",
};

export const ColorFromPriority = {
  1: "orange lighten-2",
  2: "red lighten-1",
};
